<template>
  <div class="home">
    <img alt="Eloca" src="../assets/logoog.png">
    <h3>Bem vindo!</h3>
  </div>
</template>

<script>
export default {
  name: 'Home',
};
</script>

<style lang="scss">
  .home {
    background-color: #fff;
    text-align: center;
    height: calc(100vh - 40px);

    img {
      margin-top: 20vh;
      max-width: 500px
    }
  }
</style>
